module.exports = __webpack_public_path__ + "img/beem-01.38db280e.png";